import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { locationAutoCompleteInput$, locationAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const LocationAutoSuggest = renderAutoSuggestWithOptions(
   locationAutoCompleteObservable$,
   locationAutoCompleteInput$,
);

LocationAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   forceSelection: false,
   placeholder: 'Search Locations...',
};

export default LocationAutoSuggest;
